import { render, staticRenderFns } from "./StatusAtualizacaoProcesso.vue?vue&type=template&id=4a6b8808&scoped=true&"
import script from "./StatusAtualizacaoProcesso.vue?vue&type=script&lang=js&"
export * from "./StatusAtualizacaoProcesso.vue?vue&type=script&lang=js&"
import style0 from "./StatusAtualizacaoProcesso.vue?vue&type=style&index=0&id=4a6b8808&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6b8808",
  null
  
)

export default component.exports